import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetServiceCategoryColumnChartValuesResultType,
    GetServiceCategoryLineChartValuesResultType,
    GetServiceCategoryMetricsValuesResultType,
    GetServiceCategoryValuesResultType,
    ReportResultColumnDto,
    ServiceCategoryClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceCategoryService extends CustomReportServiceBase<ServiceCategoryClient, CustomReportServiceView> {
    constructor(protected override client: ServiceCategoryClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceCategoryValuesResultType[]> {
        return await lastValueFrom(this.client.serviceCategoryGetServiceCategoryValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.serviceCategoryGetServiceCategoryBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceCategoryColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceCategoryGetServiceCategoryColumnChartValues(parameters));
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceCategoryMetricsValuesResultType> {
        return await lastValueFrom(this.client.serviceCategoryGetServiceCategoryMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceCategoryLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceCategoryGetServiceCategoryLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.serviceCategorySaveCatalogReport(body));
        else return await lastValueFrom(this.client.serviceCategorySaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceCategoryGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.serviceCategoryCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceCategoryGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.serviceCategoryResultAvailableColumns(organizationIds));
    }
}
